import React, { useState, useRef, useMemo, useEffect } from 'react';
import LS from '../../styles/layoutStyled';
import CS from '../../styles/componentStyled';
import styled from 'styled-components';
import InputModal from '../InputModal';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { userIdState } from '../../atom/TokenAtom';
import {
  blankDefaultMsgRecoil,
  errorMsgRecoil,
  confirmMsgRecoil,
  entranceAddStateRecoil,
} from '../../atom/ModalAtom';
import {
  RoomInforDto,
  RoomPeopleDto,
  RoomPeoplesDto,
} from '../../model/room.dto';
import { socketio } from '../../api/socket.api';
import { roomAPI } from '../../api/axiosIndex';
import { Icon } from '../../component/Icon';

interface EntranceAddProps {
  pickLineId: number | null;
  roomInfor: RoomInforDto | null;
  onListUpdate: () => void;
}

const EntranceAdd = ({
  pickLineId,
  roomInfor,
  onListUpdate,
}: EntranceAddProps) => {
  const blankMsg = useRecoilValue(blankDefaultMsgRecoil);
  const setError = useSetRecoilState(errorMsgRecoil);
  const setConfirm = useSetRecoilState(confirmMsgRecoil);

  const [userId, setUserId] = useRecoilState(userIdState);

  const userSelectBoxRef = useRef<HTMLSelectElement>(null);

  const setModalState = useSetRecoilState(entranceAddStateRecoil);

  const [entryPossiblePeoples, setEntryPossiblePeoples] =
    useState<RoomPeoplesDto | null>(null);
  const [entryUserId, setEntryUserId] = useState('');
  const [entryUserName, setEntryUserName] = useState<string | undefined>('');

  const getEntryPossiblePeoples = async () => {
    try {
      const response = await roomAPI.getEntryPossiblePeoples(
        Number(roomInfor?.id),
      );
      setEntryPossiblePeoples(response.data);
    } catch {
      setError('입차 가능한 인원 조회에 실패하였습니다.');
    }
  };

  const handleUserSelectBoxChange = (
    e: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    setEntryUserId(e.target.value);
    const user = entryPossiblePeoples?.find(
      (list) => list.userId === Number(e.target.value),
    );
    setEntryUserName(user?.userNumber);
    userSelectBoxRef.current?.classList.add('selected');
  };

  const handleConfirm = async () => {
    if (entryUserId === '') {
      setError(blankMsg);
      return;
    }
    try {
      await roomAPI.postEntryOrder(Number(pickLineId), Number(entryUserId));
      socketio.entry(Number(pickLineId));
      setConfirm(`${entryUserName} 님이 입차되었습니다.`);
    } catch {
      setError('입차에 실패하였습니다.');
    }

    setModalState(false);
  };

  useEffect(() => {
    getEntryPossiblePeoples();
  }, []);

  return (
    <>
      <InputModal
        title="입차 추가"
        onCancel={() => setModalState(false)}
        onConfirm={handleConfirm}
      >
        <ul className="input-wrap">
          <li>
            <h2>
              기사 리스트
              <span className="img-box">
                <Icon name="StarIcon" size="100%" color="#FF5151" />
              </span>
            </h2>
            <CS.SelectType1>
              <select
                ref={userSelectBoxRef}
                onChange={handleUserSelectBoxChange}
                value={entryUserId}
              >
                <option value="" disabled={true}>
                  기사를 선택해 주세요.
                </option>
                {entryPossiblePeoples?.map((list) => (
                  <option value={list.userId} key={list.id}>
                    {list.userNumber}
                  </option>
                ))}
              </select>
              <span className="img-box">
                <Icon name="ArrowBottomIcon" size="100%" color="#D8D7DC" />
              </span>
            </CS.SelectType1>
          </li>
        </ul>
      </InputModal>
    </>
  );
};

export default EntranceAdd;
